import { FC } from 'react'
import { PageType } from '@app-types/PageType'
import SavePageModal from './SavePageModal'
import AddToStatsModal from '@components/Home/AddToStatsModal'

type QuickActionsProps = {
  isScrolling: boolean
  isPending: boolean
  toggleScroll: () => void
  basePath: string
  type: PageType
  isMarked: boolean
  handleBookmark: () => void
  getReadPageCount: () => number
  page: number
}

export const QuickActions: FC<QuickActionsProps> = ({
  basePath,
  type,
  getReadPageCount,
  page,
}) => {
  return (
    <div className="flex justify-around items-center w-full px-2 py-4 bg-surface-subtle border border-main rounded-2xl">
      <div className="flex flex-col items-center gap-2 flex-1">
        <SavePageModal basePath={basePath} type={type} />
        <span className="text-[11px] text-muted font-semibold uppercase tracking-tight">Kaydet</span>
      </div>

      <div className="w-[1px] h-10 bg-main mx-2"></div>

      <div className="flex flex-col items-center gap-2 flex-1">
        <AddToStatsModal
          fromReadingPage
          defaultType={type}
          readPageCount={getReadPageCount()}
          currentPage={page}
        />
        <span className="text-[11px] text-muted font-semibold uppercase tracking-tight">İstatistik</span>
      </div>
    </div>
  )
}

export default QuickActions
